const hex_to_rgba = (hex, a = 1) => {
  if (!hex || hex.indexOf("#") == -1) {
    return "rgba(0,0,0,0)";
  }
  if (hex.length != 7 && hex.length != 4) {
    console.error(`${hex} is not hex color`);
    return "rgba(0,0,0,0)";
  }
  let s = hex.replace("#", "").match(/^(..?)(..?)(..?)/);
  return `rgba(${parseInt(
    "0x" + s[1] + (s[1].length == 1 ? s[1] : "")
  )},${parseInt("0x" + s[2] + (s[2].length == 1 ? s[2] : ""))},${parseInt(
    "0x" + s[3] + (s[3].length == 1 ? s[3] : "")
  )},${Number(a)})`;
};

/**
 * 精度判断
 * @param {String} v v=number时，传入999. , 返回的数值会被忽略.
 * @param {Number} digits   -10,-1,1,2,3,4
 */
const fix_digits = (v, digits) => {
  if (!digits) {
    return v ? Math.floor(v) : v;
  }
  if (!v && v !== 0) return v;
  if (digits <= 0) {
    return Math.floor(v);
  }
  let string_v = `${v}`;
  let d = string_v.split(".");
  if (!d[1] || d[1].length <= digits) {
    return string_v;
  }
  d[1] = d[1].split("");
  d[1].length = digits;
  d[1] = d[1].join("");
  return d[0] + "." + d[1];
};
/**
 * 字符串截短
 * @param str 原字符串
 * @param n 保留位数
 * @param _pre 是否保留pre ，默认true
 * @param _next 是否保留next ，默认true
 */
const shortStr = (str, n, _pre = true, _next = true) => {
  if (!str || Object.prototype.toString.call(str) != "[object String]") {
    return "";
  }
  if (Number.isNaN(Number(n)) || Number(n) === 0) {
    return str;
  }
  if (str.length <= n) {
    return str;
  }
  const len = Math.ceil(n / 2);
  let pre = str.slice(0, len);
  let next = str.slice(str.length - len, str.length);
  return (_pre ? pre : "") + "..." + (_next ? next : "");
};

const delay = (timeout) => {
  return new Promise((resolve) => {
    setTimeout(resolve, timeout);
  });
};

// 判断语言是否在语言列表中
const isLang = (lang) => {
  const langList = ["en_US", "ko_KR", "zh_CN", "zh_TW"];
  const obj = {
    en_US: "en-us",
    ko_KR: "ko-kr",
    zh_CN: "zh-cn",
    zh_TW: "zh-tw",
  };
  const isLang = langList.includes(lang);
  return isLang ? obj[lang] : "en-us";
};

// MD5缓存相关函数
const getCachedMD5 = (key) => {
  const cachedData = sessionStorage.getItem(key);
  if (!cachedData) {
    return null;
  }
  const data = JSON.parse(cachedData);
  return data;
};

const setCachedMD5 = (key, data) => {
  sessionStorage.setItem(key, JSON.stringify(data));
};

export default {
  hex_to_rgba,
  fix_digits,
  shortStr,
  delay,
  isLang,
  getCachedMD5,
  setCachedMD5,
};
